import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Phone,
  Radio,
  Wifi,
  Users,
  Shield,
  ShieldCheck,
  Bug,
  Laptop,
  ArrowRight,
} from "lucide-react";

const solutions = [
  { icon: Phone, key: "skydial", color: "text-textBlue", bgColor: "bg-blueLight" },
  { icon: Radio, key: "voiceapi", color: "text-secondaryOrange", bgColor: "bg-orange-50" },
  { icon: Users, key: "aicounting", color: "text-purple-600", bgColor: "bg-purple-50" },
  { icon: Shield, key: "vms", color: "text-emerald-600", bgColor: "bg-emerald-50" },
  { icon: ShieldCheck, key: "soc", color: "text-red-600", bgColor: "bg-red-50" },
  { icon: Bug, key: "vapt", color: "text-amber-600", bgColor: "bg-amber-50" },
  { icon: Laptop, key: "firstprotect", color: "text-indigo-600", bgColor: "bg-indigo-50" },
  { icon: Wifi, key: "networking", color: "text-textBlueDark", bgColor: "bg-backgroundTeal" },
];

const SolutionsSection = () => {
  const { t } = useTranslation();

  return (
    <section id="solutions" className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white hairline scroll-mt-24">
      <div className="container-page">
        <div className="mb-14 max-w-3xl">
          <span className="kicker mb-4">{t("solutions.label")}</span>
          <h2 className="text-4xl tablet:text-3xl mobile:text-2xl font-semibold tracking-[-0.02em] text-black">
            {t("solutions.title")}
          </h2>
        </div>

        <div className="grid grid-cols-4 tablet:grid-cols-2 mobile:grid-cols-1 gap-4">
          {solutions.map((solution) => {
            const Icon = solution.icon;
            const isSkydial = solution.key === "skydial";
            return (
              <Link
                key={solution.key}
                to={`/solutions/${solution.key}`}
                className="group flex flex-col rounded-xl border border-line bg-white p-6 transition-[border-color,background-color,transform] duration-300 hover:border-textBlue hover:bg-brand-50 hover:-translate-y-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-textBlue focus-visible:ring-offset-2"
              >
                <span className={`${solution.bgColor} w-11 h-11 rounded-xl flex items-center justify-center mb-4`}>
                  {isSkydial ? (
                    <img
                      src="/logo skydial.svg"
                      alt=""
                      width="24"
                      height="24"
                      className="w-6 h-6 object-contain"
                    />
                  ) : (
                    <Icon className={`w-5 h-5 ${solution.color}`} aria-hidden="true" />
                  )}
                </span>
                <h3 className="text-base font-semibold text-black mb-2 tracking-[-0.01em]">
                  {t(`solutions.${solution.key}.title`)}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5 flex-1 line-clamp-3">
                  {t(`solutions.${solution.key}.description`)}
                </p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-textBlue">
                  {t("solutions.viewMore")}
                  <ArrowRight
                    className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
